import $ from 'jquery';

var site = (function() {

	var sph = {};

	sph.waitFor$ = function()
	{
	   // Check if $'s loaded
	   if(typeof window.$ == 'undefined')
	   {
	     window.setTimeout(sph.waitFor$, 100);
	   }
	   else
	   {
	     sph.domReady();
	   }
	};

	sph.domReady = function()
	{
    $( document ).ready(function()
    {
		sph.loaded();
		// sph.menu();
		// sph.submenu();
		sph.addSlideshowContentDiv();
		sph.relocateSlideshowContent();
		sph.addRightColContentDiv();
		sph.relocateRightCol();
		sph.reheightSearchForm();
		// sph.clone3Lmenu();
		// sph.createMenuHeader();
		// sph.clonel4menuheader();

    });
    $( window ).on('load', function()
    {
	    sph.slideshowCaptionPlacement();
		sph.resizeOurPeopleSS();
    });

	$(window).bind("resize", function()
	{
	   sph.delay(function() {
			sph.resizeCols();
	   }, 500);

	});

	$( window ).resize(function()
	{
		sph.relocateSlideshowContent();
		sph.relocateRightCol();
		sph.slideshowCaptionPlacement();
		sph.reheightSearchForm();
		sph.resizeOurPeopleSS();
	});

	};

	sph.delay = function()
	{
	 	var e = 0;
	    return function(t, n) {
	       clearTimeout(e);
	       e = setTimeout(t, n);
		   };
	};

	sph.loaded = function()
	{
		// console.log( 'loaded' );
	};

	sph.menu = function()
	{

				//Add main nav toggle
		$('#main_nav ul.group:first')
			.prepend('<li><a href="#" class="main_nav__toggle close">&times;</a></li>')
	 		.before('<a href="#" class="main_nav__toggle menu"></a>')
			.end()
			.find('.main_nav__toggle').click(function(e) {
				e.preventDefault();
				$('body').toggleClass('show-responsive-nav');
			})
			.end();

		$( '.siteTitle h4' )
			.append( '<a href="#" class="site_nav__toggle">▼</a>' )
			.find('.site_nav__toggle').click(function(e) {
				e.preventDefault();
				$('#sidebar').slideToggle( 500 );
				if ( $('.site_nav__toggle').html() == '▼' ) {
						$('.site_nav__toggle').html( '▲' );
				} else {
						$('.site_nav__toggle').html( '▼' );
				}

			})
			.end();
	};

	sph.submenu = function()
	{
		//If subnav has a child with class of active path
		if( $('.subnav').find('.activenavpath ul').length > 0 )
		{
			var $active = $('.activenavpath').last(),
          $submenu = $active.find('ul').html(),
          $title = $active.children('a:first').text();

      if(!$submenu)
      {
        $submenu = $active.parents('ul').first().html();
        $title = $active.parents('ul').first().prev().text();
      }

			var	$output = '<div class="mobile-sub-menu"><span>' + $title + '</span><ul>' + $submenu + '</ul></div>';

			$('h1:first').after($output);

			$('.mobile-sub-menu span').on('click', function(event) {
				event.preventDefault();
				$(this).toggleClass('show').next('ul').slideToggle();
			});
		}
	};

	sph.addSlideshowContentDiv = function()
	{
		// let's create an empty container div to receive the appendTo content
		var $slideshowContent = $( '.fw_fContainer_module.regularSS' ) || null;
		if ( $slideshowContent.length > 0 ) {
			$('#sidebar').after('<div id="sscw" class="cf"></div>');
		}
	};

	sph.relocateSlideshowContent = function()
	{
		// get all HTML in #cent-inst_featuredImg that is NOT subnav1
		var $slideshowContent = $( '.fw_fContainer_module.regularSS' );
		var $movedSlideshowContent = $( '#sscw > *' ) || null ;
		if ($(window).width() <= 1199) {
			$slideshowContent.appendTo( '#sscw' );

		} else {
			if ( $movedSlideshowContent !== null ) {
				$movedSlideshowContent.appendTo( '.cent-inst_featuredImg' );
			}
		}
	};

	sph.slideshowCaptionPlacement = function()
	{
		var $slideshowImg = $('.fw_slideshow .fw_img a img');
		var $slideshowCaption = $( '.fw_slideshow > .fw_txt');
		var elementImgHeights = $( $slideshowImg ).map(function() {
		    return $(this).height();
		  }).get();
		var maxHeight = Math.max.apply(null, elementImgHeights );

		// Set each height to the max height but only on smaller window widths
		if ($(window).width() < 1010) {
		  $( $slideshowCaption ).height( maxHeight );
		  $( $slideshowCaption ).css( "margin-top", -maxHeight );
		}

		 // console.log( maxHeight );

	};

	sph.addRightColContentDiv = function()
	{
		var $clf_fpn_blog = $( '#clf-fpn-blog' );
		if ( $clf_fpn_blog.length > 0 ) {
				$('#page .row.tall').append('<div id="rccw" class="object w25"></div>');
		}
	};

	sph.relocateRightCol = function()
	{
		// get all HTML that IS .rightCol; including itself
		var $rightCol = $( '#page .rightCol' );
		var $movedrightCol = $( '#rccw .rightCol' ) || null ;
		if ($(window).width() < 1010) {
			$rightCol.appendTo( '#rccw' );
		} else {
			if ( $movedrightCol !== null ) {
				$('.content.landing h1').after( $movedrightCol );
			}
		}
	};

	sph.reheightSearchForm = function()
	{

		var sTheight = $('.siteTitle').height();
		var submitTop = ( ( sTheight - 52 ) / 2 );

		// console.log( sTheight );
		// console.log( submitTop );

		if ( ( $(window).width() < 1010) & ( sTheight > 51 ) ) {
				$( '.sitesearchv3-form' ).height(sTheight);
				$( '.sitesearchv3-form--text' ).height(sTheight);
				$( 'li.sitesearchv3-form--submit' ).height(sTheight);
				$( 'li.sitesearchv3-form--submit input' ).css( 'top', submitTop );
		}
	};

	sph.clone3Lmenu = function()
	{
		var $menu3Lnokids = $( '.secondary-nav > .secondary-nav1 > ul' );
			$menu3Lnokids.addClass( 'm3lnk' );

		var $menu3L = $( '.secondary-nav > .secondary-nav1 > ul > li.activenavpath > ul' );

			$menu3L.addClass( 'm3l' );

		var $menu4L = $( '.secondary-nav > .secondary-nav1 > ul > li.activenavpath > ul > li.activenavpath > ul' );
			$menu4L.addClass( 'm4l' );

		var $menu5L = $( '.secondary-nav > .secondary-nav1 > ul > li.activenavpath > ul > li.activenavpath > ul > li.activenavpath > ul' );

		var $menu2Lactive = $( '.mobile-sub-menu li.activenavpath' );

		// DOM conditions

		var pageLevel;

			// 2L page no kids
			if ( ( 0 === $menu3L.length ) && ( 0 === $menu3Lnokids.length ) ) {
				pageLevel = 'L2_nokids';
			}
			// 2L page with kids or 3L page no kids
			else if ( ( 0 === $menu3L.length ) && ( 1 == $menu3Lnokids.length ) ) {
				pageLevel = 'L2_kids';
			}
			// 3L page without kids
			else if ( ( 1 == $menu3L.length ) ) {
				pageLevel = 'L3_nokids';
			}
			// 3L with kids
			else if ( ( 1 == $menu3L.length ) && ( 1 == $menu4L.length ) ) {
				pageLevel = 'L3_kids';
			}

		if ( 'L2_kids' == pageLevel ) {
			label = $( '.subnav.horizontal1 li.activenavpath a' ).html();

			// console.log( label );
			$( '.mobile-sub-menu span' ).text( label );
		}

		if ( 0 === $menu4L.length ) {
			$menu3L.clone().addClass( 'appendedTo').appendTo( $menu2Lactive );
		} else if ( ( 1 == $menu4L.length ) ) { // &&  ( 0 == $menu4L.length ) ) {
			$menu4L.clone().addClass( 'appendedTo').appendTo( $menu2Lactive );
		}

		$( '.mobile-sub-menu li.activenavpath > ul' ).remove();

		// console.log( $menu3Lnokids );

		// console.log( $menu3L );

		// console.log( $menu4L );

		// console.log( pageLevel );

	};
	sph.clone3Lmenuheader = function() {
		var $activenavpath = $( '#sidebar .subnav > ul > .activenavpath > a' );
		var $container = $( '.mobile-sub-menu > span' );
		// console.log ( $activenavpath.html() );
		$container.html( $activenavpath.html() );
	};

	sph.clonel4menuheader = function()
	{
		var $activenavpath = $( '#sidebar .subnav > ul > .activenavpath ul > .activenavpath > a' );
		var $container = $( '.mobile-sub-menu > span' );
		$container.html( $activenavpath.html() );
	};

	sph.resizeOurPeopleSS = function()
	{
		var	$ourPeopleF = $( 'div.ourPeopleF' );
		var fssHt = $('#facultyss').height();
		// console.log( fssHt );
		$ourPeopleF.height( fssHt - 35 );
	};

	sph.createMenuHeader = function()
	{
		var $container = $( '.mobile-sub-menu > span' ); // this doesn't change

		// third level menu
		var $activenavpath3l = $( '#sidebar .subnav > ul > .activenavpath > a' );

		// fourth level menu
		var $activenavpath4l = $( '#sidebar .subnav > ul > .activenavpath ul > .activenavpath > a' );

		// console.log( $container );
		// console.log( $activenavpath3l );
		// console.log( $activenavpath4l );

	};

	return sph;

}());

site.waitFor$();
